// START: GitHub Copilot Generated Code
/**
 * Result utility functions — no store dependency.
 * Extracted from utilities.ts to break the circular dependency chain:
 * store.ts → contentSlice.ts → apiServices.ts → utilities.ts → languageService.ts → store.ts
 *
 * ADA/OWASP: Pure data-shaping helpers with no side effects.
 */
import { Result } from "../types/result";

export const FailedResult = <T>(
    message?: string,
    error?: unknown,
    data?: T,
): Result<T> => {
    const result: Result<T> = {
        ok: false,
        message: message,
        error: error,
        data: data,
    };
    return result;
};

export const ToFailedResult = <TIn, TOut>(
    result: Result<TIn>,
): Result<TOut> => {
    const failedResult: Result<TOut> = {
        ok: false,
        message: result?.message,
        error: result?.error,
    };
    return failedResult;
};

export const OkResult = <T>(data: T, message?: string): Result<T> => {
    const result: Result<T> = {
        ok: true,
        data: data,
        message: message,
    };
    return result;
};

export const GeneralResult = <T>(data?: T, message?: string): Result<T> => {
    const result: Result<T> = {
        ok: data !== undefined && data !== null,
        data: data,
        message: message,
    };
    return result;
};
// END: GitHub Copilot Generated Code
